import { DonationField, PaymentSchedule } from '../constants';
import { DTD_ID } from './sessionStorage';

export const getSoftCreditType = (
  proxyType: string
): 'TR_PARTICIPANT' | 'TR_TEAM' | 'TR_EVENT' => {
  switch (proxyType) {
    case '20':
      return 'TR_PARTICIPANT';
    case '22':
      return 'TR_TEAM';
    default:
      return 'TR_EVENT';
  }
};

/**
 * Blackbaud form field names have embedded periods! Very developer unfriendly.
 * This helper method converts sensible field names to the blackbaud format.
 * It is easier to convert in one place that to expose the strange names throughout the code.
 * @param formData
 * @param queryStrings
 */
export const blackbaudFormMapper = (formData: any, queryStrings?: any): any => {
  const {
    df_id: form_id,
    fr_id,
    proxy_id: PROXY_ID,
    proxy_type: PROXY_TYPE,
  } = queryStrings;

  // TODO: not able to use the created hook
  const dtdId =
    window.location.hostname !== 'fundraising.stjude.org'
      ? sessionStorage.getItem(DTD_ID)
      : '';

  const isMonthlyPayment: boolean =
    formData[DonationField.paymentSchedule] === PaymentSchedule.Monthly;

  const paymentSchedule = isMonthlyPayment
    ? { level_autorepeat: true }
    : undefined;

  const billingAddress3 = formData[DonationField.address3]
    ? { 'billing.address.street3': formData[DonationField.address3] }
    : undefined;

  return {
    ...paymentSchedule,
    'billing.address.street1': formData[DonationField.address1],
    'billing.address.street2': formData[DonationField.address2],
    ...billingAddress3,
    'billing.address.city': formData[DonationField.city],
    'billing.address.state': formData[DonationField.state],
    'billing.address.zip': formData[DonationField.postCode],
    'billing.address.country': formData[DonationField.country],
    'billing.name.first': formData[DonationField.firstName],
    'billing.name.last': formData[DonationField.lastName],

    'donor.email': formData[DonationField.donorEmail],
    'donor.email_opt_in': formData[DonationField.donorEmailOptIn],
    other_amount: formData[DonationField.donationAmount],
    level_id: formData[DonationField.donationLevelId],

    'teamraiser.message_to_participant':
      formData[DonationField.donationPersonalNote],
    'teamraiser.recognition_name': formData[DonationField.donationDisplayName],
    'teamraiser.show_gift_to_public':
      !formData[DonationField.hideDonationAmount],
    ...(dtdId && { double_the_donation_company_id: JSON.parse(dtdId || '') }),
    anonymous: formData[DonationField.hideMyDisplayName],
    form_id: parseInt(String(form_id)),
    fr_id: parseInt(String(fr_id)),
    soft_credit_id: parseInt(String(PROXY_ID)),
    soft_credit_type: getSoftCreditType(PROXY_TYPE as string),
  };
};
